import idlImport from './reversi_assets.did.js';
export const idlFactory = idlImport;
export const canisterId = "q6avi-dyaaa-aaaah-qbpda-cai";
